import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

let localStorageLanguage = 'en-US';
if (typeof sessionStorage !== 'undefined') {
  try {
    localStorageLanguage = sessionStorage.getItem('@contenta-language');
    if (!localStorageLanguage || localStorageLanguage === 'undefined') {
      localStorageLanguage = 'en-US';
      sessionStorage.setItem('@contenta-language', localStorageLanguage);
    }
  } catch (error) {
    console.warn('sessionStorage not available:', error);
  }
}

// Each locale is ~260KB of translation JSON. Loading both eagerly used to
// ship ~520KB of strings nobody reads (half the app's users never see the
// other language). Load only the active one at boot; fetch the rest lazily
// when the user actually switches via loadLanguage().
const localeLoaders = {
  'pt-BR': () => import('./locales/pt-br'),
  'en-US': () => import('./locales/en-us'),
};

const activeLang = localeLoaders[localStorageLanguage]
  ? localStorageLanguage
  : 'en-US';

export async function loadLanguage(lang) {
  // Callers have handed this menu keys and undefined. hasResourceBundle throws
  // on anything that is not a string, so the guard comes first.
  const loader = localeLoaders[lang];
  if (!loader) return;
  if (i18n.hasResourceBundle(lang, 'translations')) return;
  const { default: resources } = await loader();
  i18n.addResourceBundle(
    lang,
    'translations',
    resources.translations,
    true,
    true
  );
}

export const i18nReady = localeLoaders[activeLang]().then(
  ({ default: resources }) =>
    i18n.use(initReactI18next).init({
      resources: { [activeLang]: resources },
      lng: activeLang,
      fallbackLng: 'en-US',
      defaultNS: 'translations',
    })
);

export default i18n;
